<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          Реквизиты документа, удостоверяющего личность должника
        </div>
      </v-col>
      <v-col cols="5">
        <v-select
          v-model="v.code.$model"
          :errorMessages="getValidationErrorText(v.code)"
          :disabled="disabled"
          :items="identityDocuments"
          item-value="code"
          item-text="title"
          label="Тип документа"
          @change="changeCode"
          outlined
					@blur="v.code.$touch"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Серия документа"
          outlined
          v-model="v.series.$model"
          :errorMessages="getValidationErrorText(v.series)"
          :disabled="disabled"
          v-mask="token.series"
					@blur="v.series.$touch"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">{{ mdiHelpCircle }}</v-icon>
              </template>
              <Hint>
                <template v-slot:text>
                  <div>
                    Необходимо указать серию документа в формате:
                    {{ token.series.mask }}
                  </div>
                </template>
                <template v-slot:body>
                  <ul style="margin-left: 30px; margin-top: 5px">
                    <li
                      v-for="(item, index) in hints(token.series.mask)"
                      :key="index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </template>
              </Hint>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Номер документа"
          outlined
          v-model="v.number.$model"
          :errorMessages="getValidationErrorText(v.number)"
          :disabled="disabled"
          v-mask="token.number"
					@blur="v.number.$touch"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">{{ mdiHelpCircle }}</v-icon>
              </template>
              <Hint>
                <template v-slot:text>
                  <div>
                    Необходимо указать номер документа в формате:
                    {{ token.number.mask }}
                  </div>
                </template>
                <template v-slot:body>
                  <ul style="margin-left: 30px; margin-top: 5px">
                    <li
                      v-for="(item, index) in hints(token.number.mask)"
                      :key="index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </template>
              </Hint>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <DateFieldCustom
          label="Дата выдачи"
          :value="v.docDate.$model"
          @change="v.docDate.$model = $event"
          :errorMessage="v.docDate"
          :disabled="disabled"
          :max="new Date().toISOString()"
					@blur="v.docDate.$touch"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          label="Кем выдан"
          outlined
          v-model="v.issuer.$model"
          :errorMessages="getValidationErrorText(v.issuer)"
          :disabled="disabled"
					@blur="v.issuer.$touch"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Код подразделения"
          outlined
          v-mask="['###-###']"
          v-model="v.issuerCode.$model"
          :errorMessages="getValidationErrorText(v.issuerCode)"
          :disabled="disabled"
					@blur="v.issuerCode.$touch"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiHelpCircle } from '@mdi/js';

import DateFieldCustom from '@/components/base/DateFieldCustom';
import { getValidationErrorText } from '@/utils/validate';
import hints from '@/utils/mask';
import Hint from '../../../../base/Hint';
import { getIdentityDocumentToken } from '@/utils/services';
import { IdentityDocumentsNoticeRecoveryModule } from '@/store/modules/identityDocumentsNoticeRecovery';

export default {
  name: 'IdentityDocument',
  props: {
    v: Object,
    disabled: Boolean,
  },
  components: {
    Hint,
    DateFieldCustom,
  },
  data: () => ({
    getValidationErrorText,
    mdiHelpCircle,
    hints,
  }),
  computed: {
    identityDocuments() {
      return IdentityDocumentsNoticeRecoveryModule.list;
    },

    token() {
      return getIdentityDocumentToken(this.v.code.$model);
    },
  },
  async mounted() {
    if (
      !IdentityDocumentsNoticeRecoveryModule.loading &&
      !IdentityDocumentsNoticeRecoveryModule.loaded
    ) {
      await IdentityDocumentsNoticeRecoveryModule.loadAllIdDocsNoticeRecovery();
    }
  },
  methods: {
    changeCode() {
      this.reset();
      this.v.$reset();
    },
    reset() {
      this.v.number.$model = '';
      this.v.series.$model = '';
      this.v.docDate.$model = '';
      this.v.issuer.$model = '';
      this.v.issuerCode.$model = '';
    },
  },
};
</script>

<style scoped></style>
